import React from 'react';
import { Link } from 'react-router-dom';
import ResetPasswordForm from './ResetPasswordForm';
import singlePageStyles from '../common/SinglePage.module.scss';
import Layout from '../global/Layout';
import { useTranslation } from 'react-i18next';
const ResetPasswordPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className={singlePageStyles.wrapper}>
        <h1>{t('pages.resetPassword.title')}</h1>

        <ResetPasswordForm />

        <div className={singlePageStyles.otherActions}>
          <Link to='/login'>{t('pages.resetPassword.otherActions.login')}</Link>
          <Link to='/register'>{t('pages.resetPassword.otherActions.register')}</Link>
        </div>
      </div>
    </Layout>
  );
};

export default ResetPasswordPage;
